import { render, staticRenderFns } from "./EnpsDashboardPage.vue?vue&type=template&id=35fa67c7"
import script from "./EnpsDashboardPage.vue?vue&type=script&lang=js"
export * from "./EnpsDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./EnpsDashboardPage.vue?vue&type=style&index=0&id=35fa67c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports